/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { makeAutoObservable } from 'mobx';
// @ts-expect-error TS2307
import BPMNModdle from 'bpmn-moddle';
import { getBusinessObject } from 'bpmn-js/lib/util/ModelUtil';

export function containsUserTasks(elements) {
  let found = false;
  elements.forEach((el) => {
    if (getBusinessObject(el)?.$type?.toLowerCase() === 'bpmn:usertask') {
      found = true;
    }
  });
  return found;
}

export class DetectUserTasksStore {
  hasUserTasks = false;

  constructor() {
    makeAutoObservable(this);
  }

  setContainsUserTasks = (bool) => {
    this.hasUserTasks = bool;
  };

  detectContainsUserTasks = async (xml) => {
    try {
      if (xml) {
        const bpmnModdle = new BPMNModdle();
        const { elementsById } = await bpmnModdle.fromXML(xml);
        return containsUserTasks(Object.values(elementsById));
      }
    } catch (e) {
      console.info(e);
    }
    return false;
  };
}

export default new DetectUserTasksStore();
